import React from "react";
import { GridElementFullWidth, InputGroupTitle, InputLabel } from "../style";
import {
  TextField,
} from "@mui/material";
import { MandatoryStarWrapper } from "utility/styled-components";
import { customiseMaterialUITextBoxStyle } from "utility/styles";
import { FormError, FormSuggestion } from "shared-compoents/form-components";
import { questionList } from "utility/constants";
import { FieldErrors, UseFormRegister } from "react-hook-form";
import { PodOnboardingStep2FieldEnum, Step2FieldsInterface } from "../ducks/types";

function PodOnboardingStep2({ register, errors }: Readonly<{
  register: UseFormRegister<Step2FieldsInterface>, 
  errors: FieldErrors<Step2FieldsInterface>,
}>) {
  return (
    <>
      {
        questionList.map((questionCollection, index) => (
          <GridElementFullWidth key={ index+1 }>
            <InputGroupTitle>{ questionCollection.title }</InputGroupTitle>
            {
              questionCollection.questions.map((questionItem, questionIndex) => (
                <React.Fragment key={ questionIndex + 1 }>
                  <InputLabel>{ questionItem.label } { questionItem.required &&  <MandatoryStarWrapper>*</MandatoryStarWrapper>}</InputLabel>
                  <TextField
                      {...register(PodOnboardingStep2FieldEnum[questionItem.field as keyof typeof PodOnboardingStep2FieldEnum])}
                      fullWidth
                      sx={customiseMaterialUITextBoxStyle}
                  />
                  {
                    questionItem?.info && <FormSuggestion>{questionItem.info}</FormSuggestion>
                  }
                  {errors && errors[PodOnboardingStep2FieldEnum[questionItem.field as keyof typeof PodOnboardingStep2FieldEnum] as keyof typeof errors] ? (
                    <FormError>{errors[PodOnboardingStep2FieldEnum[questionItem.field as keyof typeof PodOnboardingStep2FieldEnum] as keyof typeof errors]?.message}</FormError>
                  ) : (
                    <></>
                  )}
                </React.Fragment>
              ))
            }
          </GridElementFullWidth>
        ))
      }
    </>
  );
}

export default PodOnboardingStep2;
